// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes rotate {from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}}

.preload-button{
    animation: 1s rotate linear infinite;
    transform-origin: 50% 50%;
}

.valid-none {
    position: relative;
    top: -26px;
    background: #615d5d;
}

.valid-error{
    position: relative;
    top: -26px;
    background: #dd0c0c;
}

.valid-success{
    position: relative;
    top: -26px;
    background: #06b815;
}

.valid-medio{
    position: relative;
    top: -26px;
    background: #ccc014;
}

.header-valid-speed{
    background: #004f87;
    color: #ddd;
}

.round-full{
    height: 22px;
    border-radius: 21px;
    width: 22px;
    padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/valid-pc/valid-pc.component.css"],"names":[],"mappings":"AAAA,mBAAmB,MAAM,uBAAuB,CAAC;IAC7C,IAAI,yBAAyB,CAAC,CAAC;;AAInC;IAEI,oCAAoC;IAEpC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB","sourcesContent":["@keyframes rotate {from {transform: rotate(0deg);}\r\n    to {transform: rotate(360deg);}}\r\n@-webkit-keyframes rotate {from {-webkit-transform: rotate(0deg);}\r\n  to {-webkit-transform: rotate(360deg);}}\r\n\r\n.preload-button{\r\n    -webkit-animation: 1s rotate linear infinite;\r\n    animation: 1s rotate linear infinite;\r\n    -webkit-transform-origin: 50% 50%;\r\n    transform-origin: 50% 50%;\r\n}\r\n\r\n.valid-none {\r\n    position: relative;\r\n    top: -26px;\r\n    background: #615d5d;\r\n}\r\n\r\n.valid-error{\r\n    position: relative;\r\n    top: -26px;\r\n    background: #dd0c0c;\r\n}\r\n\r\n.valid-success{\r\n    position: relative;\r\n    top: -26px;\r\n    background: #06b815;\r\n}\r\n\r\n.valid-medio{\r\n    position: relative;\r\n    top: -26px;\r\n    background: #ccc014;\r\n}\r\n\r\n.header-valid-speed{\r\n    background: #004f87;\r\n    color: #ddd;\r\n}\r\n\r\n.round-full{\r\n    height: 22px;\r\n    border-radius: 21px;\r\n    width: 22px;\r\n    padding-left: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
